/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
/** @jsxImportSource @emotion/react */
import { useRef, useEffect, useState } from 'react';
import { Accordion, AccordionBody } from 'Accordion';
import { useSelector } from 'react-redux';
import {
  selectItems,
  selectIsLoading,
} from '../../../../autoshipState/selectors';
import Item from './Item';
import SearchBar from './SearchBar';
import t from '@rcm/i18n-client';
import Paper from '@mui/material/Paper';

interface Props {
  open: boolean;
  onClick?: () => void;
  mobile?: boolean;
}

const Items = ({ open, onClick, mobile }: Props) => {
  const [overFlow, setOverflow] = useState<'auto' | 'scroll' | 'clip'>('auto');
  const loading = useSelector(selectIsLoading);
  const items = useSelector(selectItems<Autoship>);

  const itemsRef = useRef(null);

  const handleClick = () => {
    if (onClick) onClick();
  };

  useEffect(() => {
    const divHeight = itemsRef.current.clientHeight;
    const divPortion = Math.floor((divHeight / window.innerHeight) * 100);
    setOverflow(mobile ? 'clip' : divPortion <= 45 ? 'auto' : 'scroll');
  }, [itemsRef?.current?.clientHeight]);

  const body = (
    <div css={{ width: '100%' }}>
      <SearchBar mobile={mobile} />
      <div css={{ position: 'relative' }}>
        <div
          ref={itemsRef}
          css={{
            marginTop: mobile ? '18px' : '24px',
            padding: mobile ? '0px' : '16px',
            overflowY: overFlow,
            maxHeight: mobile ? '' : '48vh',
          }}
        >
          {!loading && items && items[0] ? (
            items.map((i, index) => {
              return (
                <div key={i.itemCode}>
                  <Item id={`${'item-' + index}`} item={i} mobile={mobile} />
                  {mobile && index < items.length - 1 ? (
                    <hr
                      css={{
                        margin: '12px 0px 14px 0px',
                        borderTop: '1px solid #AAAAAA',
                      }}
                    />
                  ) : null}
                </div>
              );
            })
          ) : (
            <div css={{ padding: '8px' }}>
              No Items selected. Add products to your order using the search
              bar.
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return mobile ? (
    <Paper
      elevation={3}
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 1,
        padding: '8px 8px 10px 8px',
      }}
    >
      {body}
    </Paper>
  ) : (
    <Accordion
      title={t('Items')}
      subTitle={items?.length ? `${items.length} ${t('in cart')}` : ''}
      open={open}
      elevation={1}
      onClick={handleClick}
    >
      <AccordionBody sx={{ paddingBottom: '20px' }}>{body}</AccordionBody>
    </Accordion>
  );
};

export default Items;
